export const getSelectInputLabel = (label: string | undefined, currency: string | undefined): string | undefined => {
	if (label === undefined) {
		return undefined;
	}

	return `${label} ${currency ? `(${currency})` : ''}`;
};
